// --------------------------------------------------------------
// Created On: 2025-04-01
// Author: Hannah Vaughan
//
// Last Modified: 2025-10-27
// Modified By: Zachary Thomas
//
// Copyright 2025 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import React from "react";
import styles from "./PanelSection.module.scss";

// Wrapper for most sections in the Remote Operation Panel.
export default function PanelSection(props: Props): Component {
  return (
    <div className="container">
      <label className={styles.controlLabel}>{props.label}</label>
      <div className="row align-items-center">{props.children}</div>
    </div>
  );
}

interface Props {
  label: string;
  children?: Children;
}
